import React, { useState, useEffect } from "react";
import ReactLoading from "react-loading";
import useClickOutside from "../../../useClickOutside";
import { useTranslation } from "react-i18next";
import { CheckFont } from "./CheckLang";
import { useDispatch } from "react-redux";
import { FunctionsLoading } from "../../Main/Statistics/FunctionsLoading";

function SelectWithSearch({
  array,
  load,
  typeCss,
  title,
  left,
  setId,
  funb,
  isEmpty,
  name,
  previousID,
  loadID,
  func,
  type,
  value,
  state
}) {
  let langmiamed = localStorage.getItem("langmiamed");
  const { t } = useTranslation();
  const [open, setopen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [newArr, setnewArr] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();
  
  useEffect(() => {
    if (isEmpty === true) {
      setSearchValue("");
    }
    setSearchValue(name);
  }, [isEmpty, name]);

  useEffect(() => {
    const updatedArray = array?.map((item) => {
      return { id: item.id, name: t(item.name) };
    });
    setnewArr(updatedArray);
  }, [array]);

  useEffect(() => {
    setFiltered(newArr);
  }, [newArr]);

  useEffect(() => {
    if (state?.target_group_id === "") {
      setSearchValue("");
    }
  }, [state?.target_group_id]);

  let domNode = useClickOutside(() => {
    setopen(false);
  });

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchValue(inputValue);
    const filtered = newArr.filter((item) =>
      item.name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFiltered(filtered);
  };

  const { LoadCitiesCustom, LoadGovernoratesCustom } = FunctionsLoading();

  const handleOptionClick = (item) => {
    if (type === "cities") {
      LoadGovernoratesCustom(item?.id);
    }
    setSearchValue(t(item.name));
    setId(item.id);
    setopen(false);
  };

  const openDropDown = (e) => {
    e.preventDefault();
    if (funb) {
      funb();
    }
    if (func) {
      func(loadID);
    }
    setopen(true);
  };

  return (
    <div className={left ? "div_creatable nomarginLeft" : "div_creatable"}>
      <div
        className={typeCss ? "view_creatable1 " : "view_creatable "}
        onClick={openDropDown}
      >
        <span style={{ fontFamily: CheckFont(searchValue) }}>
          {searchValue || `${title ? title : "Select"}`}
        </span>
        <i className="las la-angle-double-down icon_searchselect"></i>
      </div>
      {open && (
        <div
          className="select_creatable"
          ref={domNode}
          dir={langmiamed === "ar" ? "rtl" : "ltr"}
        >
          <input
            type="text"
            onChange={handleInputChange}
            placeholder={title ? title : t("target_group")}
            className="input_custm_select"
            value={searchValue}
          />
          {load === false ? (
            filtered?.map((cc) => (
              <div
                className={`choose_creatable ${
                  searchValue === cc.name ? "active_creatable" : ""
                }`}
                key={cc.id}
                onClick={() => handleOptionClick(cc)}
              >
                <span style={{ fontFamily: CheckFont(t(cc.name)) }}>
                  {t(cc.name)}
                </span>
              </div>
            ))
          ) : (
            <div className="loadinselect">
              <ReactLoading
                type="spinningBubbles"
                color="#9699c2"
                height={"7%"}
                width={"7%"}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SelectWithSearch;